import { Suspense } from "react";

import { NotFound } from "@hl/shared-features/lib/features/layout";
import loadable from "@loadable/component";
import { Route, Routes } from "react-router-dom";

import { AppProviders } from "./app-providers";
import { MINT_URL, TOOLS_URL } from "./config";
import MintPageByCollectionId from "./features/MintPage/MintPageByCollectionId";
import MintPageByOnChainId from "./features/MintPage/MintPageByOnChainId";
import TokenMetadata from "./features/MintPage/TokenMetadata";
import { HomePage } from "./features/home";
import Root from "./features/layout/Root";

const TokenReveal = loadable(
  () => import("./features/MintPage/token-reveal/TokenReveal")
);

const TokenDetailsSwitch = loadable(
  () => import("./features/token-details/TokenDetailsSwitch")
);

const MiniMintPage = loadable(
  () => import("./features/farcaster/mini-mint-page")
);

const WebRoutes = () => {
  return (
    <Root>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path={MINT_URL.tokens.mint}
          element={<MintPageByCollectionId />}
        />
        <Route
          path={MINT_URL.tokens.mintByOnChainId}
          element={<MintPageByOnChainId />}
        />
        <Route path={MINT_URL.tokens.metadata} element={<TokenMetadata />} />
        <Route path={MINT_URL.tokens.detail} element={<TokenDetailsSwitch />} />
        <Route
          path={MINT_URL.tokens.detailByRevealId}
          element={<TokenDetailsSwitch useTokenByRevealIdQuery />}
        />
        <Route path={MINT_URL.tokens.reveal} element={<TokenReveal />} />
        <Route path={"*"} element={<NotFound redirectUrl={TOOLS_URL.base} />} />
      </Routes>
    </Root>
  );
};

const MiniAppRoutes = () => {
  return (
    <Routes>
      <Route path={MINT_URL.tokens.mint} element={<MiniMintPage />} />
    </Routes>
  );
};

export const App = () => {
  const url = new URL(window.location.href);
  const isMiniApp = url.searchParams.get("miniApp") === "true";

  if (isMiniApp) {
    return (
      <Suspense fallback={""}>
        <MiniAppRoutes />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={""}>
      <AppProviders mode="privy">
        <WebRoutes />
      </AppProviders>
    </Suspense>
  );
};
